import { createNetworkEnv, readEnv } from "./createNetworkEnv";

/**
 * Keys come from .env (see .env.example). REACT_APP_NETWORK picks which backend this build
 * talks to and which authentication key signs the requests: it must be the same network as the
 * backend it points at (demo-backend.augastam.com signs with the DEMO key, and so on).
 */
const {
	NETWORK,
	BASE_URL,
	resolvePayloadEncryptionKey,
	resolvePayloadAuthenticationKey,
	isPayloadEncryptionEnabledForNetwork,
} = createNetworkEnv({
	network: readEnv("REACT_APP_NETWORK"),
	baseUrls: {
		TEST: readEnv("REACT_APP_TEST_BASE_URL"),
		DEMO: readEnv("REACT_APP_DEMO_BASE_URL"),
		UAT: readEnv("REACT_APP_UAT_BASE_URL"),
		PROD: readEnv("REACT_APP_PROD_BASE_URL"),
	},
	authenticationKeys: {
		DEMO: readEnv("REACT_APP_DEMO_AUTHENTICATION_KEY"),
		TEST: readEnv("REACT_APP_TEST_AUTHENTICATION_KEY"),
		UAT: readEnv("REACT_APP_UAT_AUTHENTICATION_KEY"),
		PROD: readEnv("REACT_APP_PROD_AUTHENTICATION_KEY"),
	},
	encryptionKey: readEnv("REACT_APP_ENCRYPTION_KEY"),
	payloadEncryptionEnabled: readEnv("REACT_APP_PAYLOAD_ENCRYPTION_ENABLED"),
});

export {
	NETWORK,
	resolvePayloadEncryptionKey,
	resolvePayloadAuthenticationKey,
	isPayloadEncryptionEnabledForNetwork,
};

export default BASE_URL;
